<div class="spinner-box">
	<mat-spinner></mat-spinner>
</div>